import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Ibu Sari Wijaya',
      location: 'Jakarta Selatan',
      rating: 5,
      text: 'Pelayanan sangat memuaskan! Kompor saya yang sudah 3 bulan tidak bisa menyala langsung diperbaiki dalam 1 jam. Teknisinya profesional dan harga sangat reasonable.',
      image: 'https://ui-avatars.com/api/?name=Sari+Wijaya&background=EF4444&color=fff&size=128'
    },
    {
      name: 'Bapak Andi Kusuma',
      location: 'Tangerang',
      rating: 5,
      text: 'Respon cepat banget! Saya hubungi malam, pagi harinya sudah datang dan langsung selesai. Garansi juga diberikan, recommended!',
      image: 'https://ui-avatars.com/api/?name=Andi+Kusuma&background=EF4444&color=fff&size=128'
    },
    {
      name: 'Ibu Diana Putri',
      location: 'Bekasi',
      rating: 5,
      text: 'Sudah 2 kali pakai jasa mereka. Service untuk kompor sangat ahli, spare part original, dan hasilnya awet. Puas banget!',
      image: 'https://ui-avatars.com/api/?name=Diana+Putri&background=EF4444&color=fff&size=128'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Testimoni
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Apa Kata Pelanggan Kami?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Ribuan pelanggan puas telah mempercayakan water heater mereka kepada kami
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-2 border-gray-200 hover:border-blue-500 hover:shadow-2xl transition-all duration-300 group">
              <CardContent className="p-6">
                {/* Quote Icon */}
                <Quote className="w-10 h-10 text-blue-600 mb-4 opacity-50" />

                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-700 mb-6 leading-relaxed">"{testimonial.text}"</p>

                {/* Customer Info */}
                <div className="flex items-center gap-4 pt-4 border-t border-gray-200">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full"
                  />
                  <div>
                    <div className="font-bold text-gray-900">{testimonial.name}</div>
                    <div className="text-sm text-gray-600">{testimonial.location}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;